import {inject, Injectable} from '@angular/core';
import {APIService} from "./api.service";
import {IDataAccessAuthorization} from "../interfaces/audit/IDataAccessAuthorization";
import {IDataAccessReasonType} from "../interfaces/audit/IDataAccessReasonType";

@Injectable({
  providedIn: 'root'
})
export class DataAccessService {

  private apiService = inject(APIService);

  logDataAccessAuthorization(authorizationDataP: IDataAccessAuthorization) {
    return this.apiService.MakePostRequest<IDataAccessAuthorization>("data-access/log-authorization", authorizationDataP);
  }

  getDataAccessReasonTypes() {
    return this.apiService.MakeGetRequest<IDataAccessReasonType[]>("data-access/reason-types");
  }
}
